import { render, staticRenderFns } from "./cardTemplateVip22.vue?vue&type=template&id=3690acfa&scoped=true&"
import script from "./cardTemplateVip22.vue?vue&type=script&lang=js&"
export * from "./cardTemplateVip22.vue?vue&type=script&lang=js&"
import style0 from "./cardTemplateVip22.vue?vue&type=style&index=0&id=3690acfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3690acfa",
  null
  
)

export default component.exports